// extracted by mini-css-extract-plugin
export default {"templatesHeader":"styles_templatesHeader__rpz8j","templatesHeader_title":"styles_templatesHeader_title__Lx3Fs","templatesHeader_actions":"styles_templatesHeader_actions__ki5Na"};